// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"d846be87","412":"caba9503"}[chunkId] + ".chunk.js";
};